import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";

export default function RequiredParams({ className, onChange }) {
  const [param, setParam] = useState("");
  const [params, setParams] = useState([]);
  const [error, setError] = useState(false);

  const addParam = () => {
    if (!param.trim()) return;
    const updated = [...params, param.trim()];
    setParams(updated);
    setParam("");
    setError(false);
    if (onChange) onChange(updated);
  };

  const removeParam = (index) => {
    const updated = params.filter((_, i) => i !== index);
    setParams(updated);
    if (updated.length === 0) setError(true);
    if (onChange) onChange(updated);
  };

  return (
    <div className={className}>
      <label className="text-sm font-sans dark:text-slate-200 text-slate-800">
        Required Parameters*
      </label>

      {/* Input and add button */}
      <div className="flex items-end space-x-4  w-1/3">
        <input
          type="text"
          value={param}
          onChange={(e) => setParam(e.target.value)}
          placeholder="Add parameter name (e.g., user_id)"
          className="w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700"
        />
        <button
          onClick={addParam}
          className="w-10 h-9  rounded-xl bg-blue-500 border border-slate-200 
            flex items-center justify-around text-xl font-semibold
            text-white
            hover:bg-blue-400 transition cursor-pointer"
        >
          <Plus/>
        </button>
      </div>

      {/* Parameter pills */}
      <div className="flex flex-wrap gap-2 mt-3">
        {params.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-1 bg-blue-100 text-blue-700 
              px-3 py-1 rounded-full text-sm"
          >
            {item}
            <Trash2
              size={14}
              className="cursor-pointer"
              onClick={() => removeParam(index)}
            />
          </div>
        ))}
      </div>

      {/* Error message */}
      {error && (
        <p className="text-red-500 text-xs mt-2">
          At least one parameter is required
        </p>
      )}
    </div>
  );
}
